'use client'

import { PageLayout } from '~/components/component-library'
import { EmptyState } from '~/components/component-library/EmptyState'

/**
 * Use with withOrgAccess to display a message when the user does not have access to the page.
 * Uses TeamsPage so the page should have a sidebar.
 */
export function UnauthorizedPage({
  customTitle = 'Access Denied',
  customMessage = 'You do not have permission to access this page.',
}: {
  customMessage?: string
  customTitle?: string
}) {
  return (
    <PageLayout>
      <EmptyState title={customTitle}>{customMessage}</EmptyState>
    </PageLayout>
  )
}
